import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  // baseURL: 'http://localhost:8000',
  headers: {
    authorization: `${localStorage.getItem('token')}`,
  },
})

export default instance
